<!-- activate/update form -->
<ui-dialog
    [open]="currentlyOpenDialog === 'EDIT_COMPANY_ADDITIONAL_INCOME'"
    [form]="editCompanyAdditionalIncome.form"
    (primaryButtonPressed)="onSave(editCompanyAdditionalIncome.companyAdditionalIncome)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="editCompanyAdditionalIncome.reset(); onCancel()"
    secondaryButtonLabel="cancel"
    (closing)="onCancel()"
    size="medium"
    header="{{ 'payroll.additional-incomes.selectIncomeType' | translate }}"
    [headerButton]="{
        label: 'payroll.additional-incomes.requestIncomeType',
        onPress: openRequestIncomeType.bind(this),
    }"
>
    <app-edit-company-additional-income
        #editCompanyAdditionalIncome
        [allCompanyAdditionalIncomes]="getAllCompanyAdditionalIncomes()"
    >
        <app-additional-income-taxation
            [companyAdditionalIncome]="editCompanyAdditionalIncome.companyAdditionalIncome"
        ></app-additional-income-taxation>
    </app-edit-company-additional-income>
</ui-dialog>
<!-- request income type form -->
<ui-dialog
    [open]="currentlyOpenDialog === 'REQUEST_CUSTOM_INCOME_TYPE'"
    [form]="requestIncomeTypeForm.form"
    (primaryButtonPressed)="onRequestIncomeType(requestIncomeTypeForm.incomeTypeRequest, requestIncomeTypeForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="requestIncomeTypeForm.reset(); onCancel()"
    secondaryButtonLabel="cancel"
    (closing)="onCancel()"
    size="small"
    header="payroll.additional-incomes.requestCustomIncomeType"
>
    <app-request-income-type #requestIncomeTypeForm> </app-request-income-type>
</ui-dialog>

<!-- confirm removal form -->
<ui-confirmation-dialog
    #formRemovalConfirmation
    header="{{ 'payroll.additional-incomes.deleteAdditionalIncome' | translate }}"
    primaryButtonLabel="{{ 'payroll.additional-incomes.delete' | translate }}"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    <ui-banner> {{ 'payroll.additional-incomes.deletingIncomeTypeNotice' | translate }}</ui-banner>
</ui-confirmation-dialog>
<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.additional-incomes.incomeTypes' | translate }}"
        [menuService]="payrollModuleMenuService"
    >
        <div class="buttons">
            <ui-button
                type="primary"
                *ngIf="showAddIncomeType"
                (click)="editCompanyAdditionalIncome.reset(); currentlyOpenDialog = 'EDIT_COMPANY_ADDITIONAL_INCOME'"
            >
                <mat-icon svgIcon="plus"></mat-icon>{{ 'payroll.additional-incomes.incomeType' | translate }}
            </ui-button>
            <app-pagination [total]="paginator.total" [current]="paginator.page" (pageChange)="paginator.page = $event">
            </app-pagination>
        </div>
    </app-header>
    <ui-banner *ngIf="pendingPayrollExists" variant="warning" class="margin-bottom-3">
        <p>{{ 'payroll.additional-incomes.pendingPayrollNotice' | translate }}</p>
    </ui-banner>

    <div class="ui table segment">
        <table class="ui selectable unstackable table">
            <thead>
                <tr>
                    <th>{{ 'payroll.additional-incomes.incomeType' | translate }}</th>
                    <th>{{ 'payroll.additional-incomes.description' | translate }}</th>
                    <th>{{ 'payroll.additional-incomes.timeOffIntegration' | translate }}</th>
                    <th>{{ 'payroll.additional-incomes.timeTrackingIntegration' | translate }}</th>
                    <th class="collapsing"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let companyAdditionalIncome of activeCompanyAdditionalIncomes"
                    [routerLink]="['/payroll', 'additional-incomes', companyAdditionalIncome.id]"
                >
                    <td>{{ companyAdditionalIncome.displayName }}</td>
                    <td>{{ companyAdditionalIncome.description || '-' }}</td>
                    <td *ngIf="!companyAdditionalIncome.timeOffEmployeeHoursExist">--</td>
                    <td *ngIf="companyAdditionalIncome.timeOffEmployeeHoursExist">
                        <ui-badge type="success">{{ 'active' | translate }}</ui-badge>
                    </td>
                    <td *ngIf="!companyAdditionalIncome.timeTrackingEmployeeHoursExists">--</td>
                    <td *ngIf="companyAdditionalIncome.timeTrackingEmployeeHoursExists">
                        <ui-badge type="success">{{ 'active' | translate }}</ui-badge>
                    </td>
                    <td>
                        <app-context-menu *ngIf="!pendingPayrollExists">
                            <app-context-item
                                label="{{ 'payroll.additional-incomes.edit' | translate }}"
                                (click)="
                                    editCompanyAdditionalIncome.startEditMode(companyAdditionalIncome);
                                    currentlyOpenDialog = 'EDIT_COMPANY_ADDITIONAL_INCOME'
                                "
                            ></app-context-item>
                            <app-context-item
                                [disabled]="!canRemove(companyAdditionalIncome)"
                                [matTooltip]="getRemoveTooltipText(companyAdditionalIncome) | translate"
                                label="{{ 'payroll.additional-incomes.remove' | translate }}"
                                (click)="
                                    canRemove(companyAdditionalIncome) &&
                                        onRemove(formRemovalConfirmation, companyAdditionalIncome)
                                "
                            ></app-context-item>
                        </app-context-menu>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
